import React, { ChangeEvent, useEffect, useState } from "react";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import { ReactComponent as CloseIcom } from "../../../../assets/icons/close.svg";
import { Box, Button, Grid, Popover, Typography } from "@mui/material";
import ViewTeamAttendanceStyles from "./ViewTeamAttendance.styles";
import CustomPageHeader from "../../../../global/components/CustomPageHeader/CustomPageHeader";
import AttendanceStatusBox from "../AttendanceStatusBox";
import TotalDaysIcon from "../../../../assets/icons/TotalIcon.svg";
import CustomTable from "../../../../global/components/CustomTable/CustomTable";
import { AttendanceHeader } from "../../AttendanceData";
import {
  attendanceApprove,
  getLeave,
  getUserWiseAttendance,
} from "../../AttendanceService";
import moment from "moment";
import customErrorHandler from "../../../../utils/customErrorHandler";
import {
  isTruthy,
  openErrorNotification,
  openSuccessNotification,
} from "../../../../helpers/methods";
import notifiers from "../../../../global/constants/NotificationConstants";
import { useAppSelector } from "../../../../utils/hooks";
import { selectUserId } from "../../../../redux/authSlice";
import { DateRangePicker, LocalizationProvider } from "@mui/x-date-pickers-pro";

import CustomButton from "../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as VerticalDotIcon } from "../../../../assets/icons/verticalDot.svg";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { getDateWiseAttendance } from "../../../Attendance copy/AttendanceService";
import { store } from "../../../../utils/store";

interface CustomProps {
  handleViewAttendanceClose: Function;
  viewInfoUserId: any;
}

const ViewTeamAttendance = (props: CustomProps) => {
  const classes = ViewTeamAttendanceStyles;
  const userIdFromRedux = useAppSelector(selectUserId);
  const [attendanceDatam, setAttendanceDatam] = useState({
    TotalDays: 0,
  });
  const [userDataSource, setUserDataSource] = useState<any>([]);
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [count, setCount] = useState<number>(5);
  const [attendanceInfo, setAttendanceInfo] = useState<any>([]);
  const [fixData, setFixData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = React.useState(0);
  const [user_id, setUser_id] = useState("");
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [viewAttendance, setViewAttendance] = useState(false);
  const [viewInfoUserId, setViewInfoUserId] = useState<string>("");
  const [forId, setForId] = useState<any>();

  const userPerPage = 10;
  const userCount = userDataSource?.length;
  const pageVisited = pageNumber * userPerPage;
  const displayRows = userDataSource?.slice(
    pageVisited,
    pageVisited + userPerPage
  );
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [leaveInfo, setLeaveInfo] = useState<any>([
    {
      total_leave: "",
      earned_leave: "",
      sick_leave: "",
      casual_leave: "",
      total_leave_available: "",
      earned_leave_available: "",
      sick_leave_available: "",
      casual_leave_available: "",
    },
  ]);

  useEffect(() => {
    init();
    getUserAttendance();
  }, []);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPageNumber(newPage);
  };

  const handleRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const init = async () => {
    try {
      const response = await getLeave(props.viewInfoUserId);
      customErrorHandler(response);
      setLeaveInfo(response.data);
    } catch (error: any) {
      if (customErrorHandler({}, error) === false) return;
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const getUserAttendance = async () => {
    try {
      const response = await getUserWiseAttendance(props.viewInfoUserId);
      customErrorHandler(response);
      let totalTime: any = "0:0";
      response.data.forEach((item: any) => {
        let time = moment(item?.working_hours, "H:m").add(totalTime, "H:m");
        totalTime = time;
        return {};
      });

      const responseData = response.data.map((item: any) => {
        return {
          date: item.date,
          punch_in: item.punch_in,
          punch_out: item.punch_out,
          working_hours: item.working_hours,
          attendace: Number(item.status) === 0 ? "Absent" : "Present",
          approver: item.approver,
          action: (
            <>
              <Box sx={classes.verticalDotButton}>
                <Button
                  onClick={(event) =>
                    handlePopOver(event, item.userId, item._id)
                  }
                >
                  <VerticalDotIcon />
                </Button>
              </Box>
            </>
          ),
        };
      });
      // setUserDataSource(response.data);
      setUserDataSource(responseData);
      setFixData([...response.data]);
    } catch (error: any) {
      if (customErrorHandler({}, error) === false) return;
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // get value from Input field
  const handleSearchOnChange = async (
    SearchEvent: ChangeEvent<HTMLInputElement>
  ) => {
    if (SearchEvent.target.value) {
      setSearch(SearchEvent.target.value.replace(/\s/g, ""));
    } else {
      setSearch("");
    }
  };
  const HandleApprove = async (viewInfoUserId: any, buttonLabel: any) => {
    try {
      const reqApprove: any = buttonLabel === "Approve" ? 1 : 2;
      const response: any = await attendanceApprove(
        userIdFromRedux,
        user_id,
        reqApprove
      );
      customErrorHandler(response);
      openSuccessNotification(response.message);
    } catch (error: any) {
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };
  const handlePopOver = (
    event: React.MouseEvent<HTMLButtonElement>,
    userId: any,
    user_id: any
  ) => {
    setAnchorEl(event.currentTarget);
    setViewInfoUserId(userId);
    setUser_id(user_id);
  };
  const dialogHeaderContent = () => {
    return (
      <Box marginTop={1} marginRight={3} sx={{ cursor: "pointer" }}>
        <CloseIcom
          onClick={() => {
            props.handleViewAttendanceClose();
          }}
        />
      </Box>
    );
  };
  {
  }
  const handelDateRange = async (value: any) => {
    const from = value[0]?.format("DD/MM/yyyy");
    const to = value[1]?.format("DD/MM/yyyy");
    if (from && to) {
      try {
        const response = await getDateWiseAttendance(
          props.viewInfoUserId,
          from,
          to
        );
        customErrorHandler(response);
        let totalTime: any = "0:0";
        response.data.forEach((item: any) => {
          let time = moment(item?.working_hours, "H:m").add(totalTime, "H:m");
          totalTime = time;
          return {};
        });
        // setUserDataSource(response.data);
        setUserDataSource([...response.data]);
        setFixData([...response.data]);
      } catch (error: any) {
        if (customErrorHandler({}, error) === false) return;
        openErrorNotification(
          isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
        );
      }
    }
  };
  const dialogTitleContent = () => {
    return (
      <>
        <Box sx={classes.attendanceWrapper}>
          <Grid container>
            <Grid item xs={6}>
              <CustomPageHeader
                heading="Attendance"
                subInfo="Manage your attendance list here"
              />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12}>
              <Box sx={classes.LeaveBoxPart}>
                <AttendanceStatusBox
                  boxHeading={"Total Leave "}
                  total={leaveInfo?.total_leave}
                  available={leaveInfo?.total_leave_available}
                  icon={TotalDaysIcon}
                  slash={leaveInfo?.total_leave && "/"}
                />
                {leaveInfo?.earned_leave <= 0 ? (
                  ""
                ) : (
                  <AttendanceStatusBox
                    boxHeading={"Earned Leave "}
                    total={leaveInfo?.earned_leave}
                    slash={leaveInfo?.earned_leave && "/"}
                    available={leaveInfo?.earned_leave_available}
                    icon={TotalDaysIcon}
                  />
                )}
                {leaveInfo?.sick_leave <= 0 ? (
                  ""
                ) : (
                  <AttendanceStatusBox
                    boxHeading={"Sick Leave "}
                    total={leaveInfo?.sick_leave}
                    available={leaveInfo?.sick_leave_available}
                    icon={TotalDaysIcon}
                    slash={leaveInfo?.sick_leave && "/"}
                  />
                )}

                {leaveInfo?.casual_leave <= 0 ? (
                  ""
                ) : (
                  <AttendanceStatusBox
                    boxHeading={"Casual Leave "}
                    total={leaveInfo?.casual_leave}
                    available={leaveInfo?.casual_leave_available}
                    icon={TotalDaysIcon}
                    slash={leaveInfo?.total_leave && "/"}
                  />
                )}
              </Box>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateRangePicker
                  onChange={(newValue) => {
                    handelDateRange(newValue);
                  }}
                  localeText={{ start: "start", end: "till" }}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} mt={2}>
              <CustomTable
                headers={AttendanceHeader}
                rows={displayRows}
                size={[5]}
                handlePageChange={handleChangePage}
                handleRowsPerPage={handleRowsPerPage}
                paginationCount={userCount}
                rowsPerPage={rowsPerPage}
                pageNumber={pageNumber}
              />

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                sx={{ top: "10px", left: "-20px" }}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <Box sx={classes.innerPopOver}>
                  {
                    <>
                      <CustomButton
                        label="Approve"
                        onClick={() => {
                          HandleApprove(viewInfoUserId, "Approve");
                        }}
                      />
                      <CustomButton
                        label="Disapprove"
                        onClick={() => {
                          HandleApprove(viewInfoUserId, "DisApprove");
                        }}
                      />
                    </>
                  }
                </Box>
              </Popover>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  return (
    <CustomDialog
      fullScreen={true}
      isDialogOpen={true}
      dialogHeaderContent={dialogHeaderContent()}
      dialogTitleContent={dialogTitleContent()}
    />
  );
};

export default ViewTeamAttendance;
